export default __webpack_public_path__ + "static/media/cupcake-3.8bd82aaa.jpeg";